import { create } from 'zustand'

const useGoogleTranslateStore = create((set) => ({
    selected: null,
    setSelected: (selected: any) => set((state: any) => ({ selected: selected })),
}))

export default useGoogleTranslateStore